import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountReadContext } from '@context/AccountContextContext'

import { DateShortcutOption } from '@ui/v2/TableFilter/Chips/FilterChipModalDateRange'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { FilterOptionsDto } from '@model/FilterOptionsDto'

import { useFetchOne } from '@hooks/useFetch'

import { CURRENT_YEAR, LAST_MONTH, THIS_MONTH } from '../../../Dashboard/constants/performance'

interface IBTransactionsFilterOptions {
  accountTypes?: FilterOptionsDto['accountTypes']
  dateShortcutOptions: DateShortcutOption[]
}

export const useIBTransactionsFilterOptions = (): IBTransactionsFilterOptions => {
  const { t } = useTranslation()
  const apiClient = useApiClient(ClientApiClient)
  const { account } = useAccountReadContext()

  const dateShortcutOptions = useMemo<DateShortcutOption[]>(() => {
    return [
      {
        name: t('Calendar.This Month'),
        range: THIS_MONTH,
      },
      {
        name: t('Calendar.Last Month'),
        range: LAST_MONTH,
      },
      {
        name: t('Calendar.Current Year'),
        range: CURRENT_YEAR,
      },
    ]
  }, [t])

  const fetchIBTransactionsFilterOptions = useCallback(async () => {
    if (!account?.clientIntroducingBroker?.id) {
      return undefined
    }

    return apiClient.getIBClientFilterOptions(account?.clientIntroducingBroker?.id)
  }, [apiClient, account])

  const { data } = useFetchOne(fetchIBTransactionsFilterOptions)

  return {
    accountTypes: data?.accountTypes || [],
    dateShortcutOptions,
  }
}
